import React from "react";
import { useTranslation } from "react-i18next";
import LearnWidgetsList from "../components/LearnWidgetList";

import SvgIcon from "../../../../parts/SvgIcon";
import { WidgetsListManager } from "../components/widgetManager/components/WidgetsListManager";
import { ExploreSelector } from "../components/ExploreSelector";
import { widgetTypesList } from "../data/widgetsLists";

const WidgetsMain = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <main className="widgets">
      <header>
        <hgroup className="mobile-hidden">
          <h3>{t("widgets.widgetsMain.title")}</h3>
          <p className="p4">{t("widgets.widgetsMain.description")}</p>
        </hgroup>
        <ExploreSelector widgetTypesList={widgetTypesList} />
        <a
          href={`/actions/refresh?modal[type]=create-widget`}
          role="button"
          data-button-type="primary"
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          <span>{t("widgets.widgetsMain.addNewWidget")}</span>
        </a>
      </header>
      <section>
        <LearnWidgetsList widgetTypesList={widgetTypesList} />
        <WidgetsListManager locals={locals} />
      </section>
    </main>
  );
};

export default WidgetsMain;
